<template>
  <div>
 <lk-auto-complete
  ref="hospitalList"
 class="hospitalList"
      v-model="val"
      :data="options"
      :filter-method='handleFilter'
      @on-change="handleChange"
      placeholder="请输入"
@on-focus="handleFirst"
     ></lk-auto-complete>
  </div>
</template>
<script>
import base from '../../services/base';
import utils from '../../libs/utils';

export default {
  name: 'prescriptionHospital',
  props: {
    value: {
      type: String,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  watch: {
    value: {
      handler(e) {
        this.val = e;
      },
      deep: true,
    },
  },
  data() {
    return {
      val: '',
      options: [],
      firstFocuse: true,
    };
  },
  methods: {
    handleFilter(val, option) {
      if (!val) {
        return false;
      }

      return val === option.slice(0, val.length);
    },
    handleChange(val) {
      this.$emit('change', val);
    },
    getData() {
      this.$store.commit('setDisableLoading', true);
      base.hospital.getHospitalList({
        status: 1, allHospital: 1,
      }).then((res) => {
        if (res.data.status === 200) {
          this.options = res.data.data.list.map(item => item.name);
          // this.val = this.value
          console.dir(this.$refs.hospitalList);
          if (this.$refs.hospitalList.$children[0]) {
            // debugger;
            this.$nextTick(() => {
              this.$refs.hospitalList.$children[0].visible = true;
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleFirst() {
      if (this.firstFocuse) {
        this.getData();
      }
      this.firstFocuse = false;
    },
  },
  mounted() {
    // this.getData();
    this.val = this.value;
  },
};
</script>
